<template>
  <div :id="'test_'+idLocality">
    <h2 class="checkbox_group_label">
      <input
          :id="'check_all_'+idLocality"
          name="check_all"
          type="checkbox"
          v-model="checkAll"
          @input="onCheckAll"
      />
      <label :for="'check_all_'+idLocality">{{localityName}}</label>
    </h2>
    <ul>
      <li v-for="(item, key) in contentSources">
        <input
            :id="'select_'+idLocality+'_'+key"
            :value="Number(key)"
            type="checkbox"
            v-model="checkedItems"
        />
        <label :for="'select_'+idLocality+'_'+key">{{item}}</label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SelectContentSource",
  props: {
    idLocality: Number,
    localityName: String,
    contentSources: Object,
  },
  data(){
    return{
      checkAll: false,
      checkedItems: [],
    }
  },
  methods:{
    onCheckAll(){
      this.checkedItems = [];
      if(!this.checkAll) {
        Object.keys(this.contentSources).forEach(key => {
              this.checkedItems.push(Number(key))
            }
        );
      }
    },
  },
  watch:{
    checkedItems(){
      this.checkAll = Object.keys(this.contentSources).length === this.checkedItems.length;
      this.$emit('input', this.idLocality, this.checkedItems)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/contentSourceMaintenanceWindow/SelectContentSource.vue